import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const CRMProcessHeader = ({
  reloadList = () => {},
  selectProcessIds = [],
  jsonFilterQuery = [],
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();
  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: "CRM", link: "/admin/crm/list" },
    { title: t("Process") },
  ];
  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectProcessIds.length === 0
                      ? "disabled text-muted"
                      : "text-danger"
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectProcessIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectProcessIds.length === 0 ? undefined : "#deletewarning"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete")}</span>
                </Link>
              </li>
            </ul>
          </div>
          <Link
            to="#"
            className={`btn ${
              jsonFilterQuery.length > 0
                ? "btn-outline-primary"
                : "btn-light border"
            } d-flex align-items-center px-4 py-2 rounded-3 shadow-sm`}
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#processFilter"
            aria-controls="processFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
            <span
              className={
                jsonFilterQuery.length > 0
                  ? "bg-primary text-white ms-1 rounded-circle fs-xs"
                  : "d-none"
              }
              style={{ minWidth: 22, minHeight: 22 }}
            >
              {jsonFilterQuery.length}
            </span>
          </Link>
          <Link
            to="#"
            className="btn btn-outline-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#kanbanExample"
            role="button"
            aria-controls="saveProcess"
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span>{t("Add Process From Templates")}</span>
          </Link>
          <Link
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
            to="/admin/crm/process/save"
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span>{t("Add New Process")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default CRMProcessHeader;
